<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.quadrimestresAnos"
                            :validations="validations.quadrimestre"
                            @change="handleQuadrimestreAnoChange"
                            label="Ano"
                            show-default-option
                            v-model="model.quadrimestreAno"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="model.quadrimestreAno
                                ? form.quadrimestresAnos.find(a => a.value === model.quadrimestreAno).quadrimestres
                                : []"
                            :validations="validations.quadrimestre"
                            @change="handleQuadrimestreChange"
                            label="Quadrimestre"
                            show-default-option
                            v-model="model.quadrimestre"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.equipes"
                            @change="handleEquipeChange"
                            default-option-text="Todas"
                            label="Equipe"
                            show-default-option
                            text-field="descricao"
                            v-model="model.equipeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :options="form.boasPraticas"
                            :select-limit="null"
                            @update:dropdownClosed="handleBoasPraticasChange"
                            label="Boas práticas"
                            option-name-key="text"
                            option-text-selecteds="boa prática"
                            v-model="model.boasPraticas"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.sexos"
                            @change="handleSexoChange"
                            default-option-text="Todos"
                            label="Sexos"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.identidadesGenero"
                            @change="handleIdentidadeGeneroChange"
                            default-option-text="Todas"
                            label="Identidade de gênero"
                            show-default-option
                            text-field="descricao"
                            v-model="model.identidadeGeneroId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-group
                            class="mb-0 fg-faixa-etaria"
                            label="Faixa etária inicial"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMinimaAnos"
                                        @change="handleIdadeMinimaAnosChange"
                                        append="Anos"
                                        name="Faixa etária inicial (Anos)"
                                        number
                                        v-model="model.idadeMinimaAnos"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMinimaMeses"
                                        @change="handleIdadeMinimaMesesChange"
                                        append="Meses"
                                        name="Faixa etária inicial (Meses)"
                                        number
                                        v-model="model.idadeMinimaMeses"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMinimaDias"
                                        @change="handleIdadeMinimaDiasChange"
                                        append="Dias"
                                        name="Faixa etária inicial (Dias)"
                                        number
                                        v-model="model.idadeMinimaDias"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-group
                            class="mb-0 fg-faixa-etaria"
                            label="Faixa etária final"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMaximaAnos"
                                        @change="handleIdadeMaximaAnosChange"
                                        append="Anos"
                                        name="Faixa etária final (Anos)"
                                        number
                                        v-model="model.idadeMaximaAnos"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMaximaMeses"
                                        @change="handleIdadeMaximaMesesChange"
                                        append="Meses"
                                        name="Faixa etária final (Meses)"
                                        number
                                        v-model="model.idadeMaximaMeses"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        :validations="validations.idadeMaximaDias"
                                        @change="handleIdadeMaximaDiasChange"
                                        append="Dias"
                                        name="Faixa etária final (Dias)"
                                        number
                                        v-model="model.idadeMaximaDias"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="disablePaciente"
                            :repository="repositories.relatorioCuidadoMulherPrevencaoCancer.paciente"
                            :request-query-string-params="pacienteSearchParams"
                            :search-fields="pacienteSearchFields"
                            text-field="nome"
                            label="Paciente"
                            placeholder="Nome, CNS, CPF ou Prontuário"
                            v-model="model.paciente"
                            @select="handlePacienteChange"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-form-checkbox
                            :label="false"
                            @change="handleBuscaAtivaChange"
                            tooltip-text="Exibe somente pessoas com pendência em uma ou mais boas práticas aplicáveis."
                            v-model="model.buscaAtiva"
                        >
                            Busca ativa
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="resultado.equipe.itens.length > 0">
            <rkm-area
                v-if="totalizadores"
                no-margin-top
                title="Totalizadores"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :value="totalizadores.totalPacientes"
                            disabled
                            label="Total de pacientes"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="totalizadores.totalEquipes"
                            disabled
                            label="Total de equipes"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="totalizadores.totalMicroareas"
                            disabled
                            label="Total de microáreas"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :value="`${totalizadores.resultado}%`"
                            disabled
                            label="Resultado (%)"
                            tooltip-top="Resultado calculado pela soma ponderada das boas práticas A, B, C e D, respeitando o denominador próprio de cada boa prática."
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <template v-if="model.boasPraticas.includes('A')">
                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.denominadorBoaPraticaA"
                                disabled
                                label="Denominador da boa prática A"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.numeradorBoaPraticaA"
                                disabled
                                label="Numerador da boa prática A"
                            />
                        </rkm-col>
                    </template>

                    <template v-if="model.boasPraticas.includes('B')">
                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.denominadorBoaPraticaB"
                                disabled
                                label="Denominador da boa prática B"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.numeradorBoaPraticaB"
                                disabled
                                label="Numerador da boa prática B"
                            />
                        </rkm-col>
                    </template>

                    <template v-if="model.boasPraticas.includes('C')">
                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.denominadorBoaPraticaC"
                                disabled
                                label="Denominador da boa prática C"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.numeradorBoaPraticaC"
                                disabled
                                label="Numerador da boa prática C"
                            />
                        </rkm-col>
                    </template>

                    <template v-if="model.boasPraticas.includes('D')">
                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.denominadorBoaPraticaD"
                                disabled
                                label="Denominador da boa prática D"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                :value="totalizadores.numeradorBoaPraticaD"
                                disabled
                                label="Numerador da boa prática D"
                            />
                        </rkm-col>
                    </template>
                </rkm-row>

                <rkm-row>
                    <rkm-col v-if="model.boasPraticas.includes('A')">
                        <rkm-form-input
                            :value="`${totalizadores.percentualBoaPraticaA}%`"
                            disabled
                            label="% Boa prática A"
                            tooltip-top="Pelo menos 1 exame de rastreamento para câncer do colo do útero, coletado, solicitado ou avaliado nos últimos 36 meses, para pessoas elegíveis de 25 a 64 anos."
                        />
                    </rkm-col>

                    <rkm-col v-if="model.boasPraticas.includes('B')">
                        <rkm-form-input
                            :value="`${totalizadores.percentualBoaPraticaB}%`"
                            disabled
                            label="% Boa prática B"
                            tooltip-top="Pelo menos 1 dose da vacina HPV para crianças e adolescentes do sexo feminino de 9 a 14 anos."
                        />
                    </rkm-col>

                    <rkm-col v-if="model.boasPraticas.includes('C')">
                        <rkm-form-input
                            :value="`${totalizadores.percentualBoaPraticaC}%`"
                            disabled
                            label="% Boa prática C"
                            tooltip-top="Pelo menos 1 atendimento presencial ou remoto em saúde sexual e reprodutiva nos últimos 12 meses, para pessoas elegíveis de 14 a 69 anos."
                        />
                    </rkm-col>

                    <rkm-col v-if="model.boasPraticas.includes('D')">
                        <rkm-form-input
                            :value="`${totalizadores.percentualBoaPraticaD}%`"
                            disabled
                            label="% Boa prática D"
                            tooltip-top="Pelo menos 1 exame de rastreamento para câncer de mama, solicitado ou avaliado nos últimos 24 meses, para pessoas elegíveis de 50 a 69 anos."
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="resultado.equipe.indeterminate"
                            @change="selectAllEquipes"
                            class="mx-2"
                            v-model="resultado.equipe.selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumnsEquipes"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="resultado.equipe.selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="fieldsEquipes"
                            :items="resultado.equipe.itens"
                            :sort-by="resultado.equipe.sortBy"
                            :sort-desc="resultado.equipe.sortDesc"
                            @sort-changed="onSortChangedEquipes"
                        >
                            <template v-slot:head(resultado)>
                                Resultado (%)
                                <span
                                    title="Resultado calculado pela soma ponderada das boas práticas A, B, C e D, respeitando o denominador próprio de cada boa prática."
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(classificacaoResultado)>
                                Classificação
                                <span
                                    title="Faixa de desempenho da equipe conforme parâmetro oficial do indicador."
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(percentualBoaPraticaA)>
                                % Boa prática A
                                <span
                                    title="Pelo menos 1 exame de rastreamento para câncer do colo do útero, coletado, solicitado ou avaliado nos últimos 36 meses, para pessoas elegíveis de 25 a 64 anos."
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(percentualBoaPraticaB)>
                                % Boa prática B
                                <span
                                    title="Pelo menos 1 dose da vacina HPV para crianças e adolescentes do sexo feminino de 9 a 14 anos."
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(percentualBoaPraticaC)>
                                % Boa prática C
                                <span
                                    title="Pelo menos 1 atendimento presencial ou remoto em saúde sexual e reprodutiva nos últimos 12 meses, para pessoas elegíveis de 14 a 69 anos."
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>

                            <template v-slot:head(percentualBoaPraticaD)>
                                % Boa prática D
                                <span
                                    title="Pelo menos 1 exame de rastreamento para câncer de mama, solicitado ou avaliado nos últimos 24 meses, para pessoas elegíveis de 50 a 69 anos."
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="info-circle" />
                                </span>
                            </template>
                        </rkm-table>

                        <rkm-area
                            v-if="model.buscaAtiva"
                            title="Busca ativa por paciente"
                        >
                            <template v-slot:trailing>
                                <rkm-dropdown
                                    class="mr-2"
                                    color="primary"
                                    cols="1"
                                    menu-class="auto-scroll"
                                    no-caret
                                    small
                                    title="Colunas"
                                    v-rkm-tooltip.hover
                                >
                                    <template v-slot:button-content>
                                        <rkm-icon icon="columns" />
                                    </template>

                                    <rkm-form-checkbox
                                        :indeterminate="resultado.paciente.indeterminate"
                                        @change="selectAllPacientes"
                                        class="mx-2"
                                        v-model="resultado.paciente.selectedAll"
                                    >
                                        Todas
                                    </rkm-form-checkbox>

                                    <rkm-form-checkbox-group
                                        :options="optionalColumnsPacientes"
                                        class="mx-2"
                                        stacked
                                        text-field="label"
                                        v-model="resultado.paciente.selectedCols"
                                        value-field="key"
                                    />
                                </rkm-dropdown>
                            </template>

                            <rkm-table
                                :fields="fieldsPacientes"
                                :items="resultado.paciente.itens"
                                :sort-by="resultado.paciente.sortBy"
                                :sort-desc="resultado.paciente.sortDesc"
                                @sort-changed="onSortChangedPacientes"
                            >
                                <template v-slot:head(boaPraticaA)>
                                    A
                                    <span
                                        title="Pelo menos 1 exame de rastreamento para câncer do colo do útero, coletado, solicitado ou avaliado nos últimos 36 meses, para pessoas elegíveis de 25 a 64 anos."
                                        v-rkm-tooltip.hover
                                    >
                                        <rkm-icon icon="info-circle" />
                                    </span>
                                </template>

                                <template v-slot:head(boaPraticaB)>
                                    B
                                    <span
                                        title="Pelo menos 1 dose da vacina HPV para crianças e adolescentes do sexo feminino de 9 a 14 anos."
                                        v-rkm-tooltip.hover
                                    >
                                        <rkm-icon icon="info-circle" />
                                    </span>
                                </template>

                                <template v-slot:head(boaPraticaC)>
                                    C
                                    <span
                                        title="Pelo menos 1 atendimento presencial ou remoto em saúde sexual e reprodutiva nos últimos 12 meses, para pessoas elegíveis de 14 a 69 anos."
                                        v-rkm-tooltip.hover
                                    >
                                        <rkm-icon icon="info-circle" />
                                    </span>
                                </template>

                                <template v-slot:head(boaPraticaD)>
                                    D
                                    <span
                                        title="Pelo menos 1 exame de rastreamento para câncer de mama, solicitado ou avaliado nos últimos 24 meses, para pessoas elegíveis de 50 a 69 anos."
                                        v-rkm-tooltip.hover
                                    >
                                        <rkm-icon icon="info-circle" />
                                    </span>
                                </template>

                                <template v-slot:cell(boaPraticaA)="{ item, value }">
                                    <rkm-icon
                                        v-if="item.boaPraticaAAplica"
                                        :class="{ green: value, red: !value }"
                                        :icon="value ? 'check' : 'times'"
                                    />

                                    <span
                                        v-else
                                        title="Não aplica"
                                        v-rkm-tooltip.hover
                                    >
                                        N/A
                                    </span>
                                </template>

                                <template v-slot:cell(boaPraticaB)="{ item, value }">
                                    <rkm-icon
                                        v-if="item.boaPraticaBAplica"
                                        :class="{ green: value, red: !value }"
                                        :icon="value ? 'check' : 'times'"
                                    />

                                    <span
                                        v-else
                                        title="Não aplica"
                                        v-rkm-tooltip.hover
                                    >
                                        N/A
                                    </span>
                                </template>

                                <template v-slot:cell(boaPraticaC)="{ item, value }">
                                    <rkm-icon
                                        v-if="item.boaPraticaCAplica"
                                        :class="{ green: value, red: !value }"
                                        :icon="value ? 'check' : 'times'"
                                    />

                                    <span
                                        v-else
                                        title="Não aplica"
                                        v-rkm-tooltip.hover
                                    >
                                        N/A
                                    </span>
                                </template>

                                <template v-slot:cell(boaPraticaD)="{ item, value }">
                                    <rkm-icon
                                        v-if="item.boaPraticaDAplica"
                                        :class="{ green: value, red: !value }"
                                        :icon="value ? 'check' : 'times'"
                                    />

                                    <span
                                        v-else
                                        title="Não aplica"
                                        v-rkm-tooltip.hover
                                    >
                                        N/A
                                    </span>
                                </template>
                            </rkm-table>
                        </rkm-area>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import { data, error, file, repository, stringCase, formats } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Enum.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    computed: {
        validations() {
            const validations = {
                periodo: { required: this.model.quadrimestre === null },
                quadrimestre: { required: this.model.periodo.start === null || this.model.periodo.end === null },
                idadeMinimaAnos: {
                    min_value: 0,
                    max_value: this.isNullOrEmptyString(this.model.idadeMaximaAnos) ? 120 : this.model.idadeMaximaAnos
                },
                idadeMinimaMeses: {
                    min_value: 0,
                    max_value: 11
                },
                idadeMinimaDias: {
                    min_value: 0,
                    max_value: 30
                },
                idadeMaximaAnos: {
                    min_value: this.isNullOrEmptyString(this.model.idadeMinimaAnos) ? 0 : this.model.idadeMinimaAnos,
                    max_value: 120
                },
                idadeMaximaMeses: {
                    min_value: 0,
                    max_value: 11
                },
                idadeMaximaDias: {
                    min_value: 0,
                    max_value: 30
                },
            }

            return validations
        },
        disablePaciente() {
            return !this.hasPeriodo && this.model.quadrimestre === null
        },
        pacienteSearchParams() {
            return this.camelObjectKeysToSnakeRecursive({
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                identidadeGeneroId: this.model.identidadeGeneroId,
                idadeMinimaAnos: this.model.idadeMinimaAnos,
                idadeMinimaMeses: this.model.idadeMinimaMeses,
                idadeMinimaDias: this.model.idadeMinimaDias,
                idadeMaximaAnos: this.model.idadeMaximaAnos,
                idadeMaximaMeses: this.model.idadeMaximaMeses,
                idadeMaximaDias: this.model.idadeMaximaDias,
            })
        },
        hasPeriodo() {
            return this.model.periodo.start !== null && this.model.periodo.end !== null
        },
        optionalColumnsPacientes() {
            return this.pacienteColumns.filter(c => !(c.fixed || false))
        },
        fieldsPacientes() {
            return this.pacienteColumns.filter(c => (c.fixed || false) || this.resultado.paciente.selectedCols.includes(c.key))
        },
        optionalColumnsEquipes() {
            return this.equipeColumns.filter(c => !(c.fixed || false))
        },
        fieldsEquipes() {
            return this.equipeColumns.filter(c => (c.fixed || false) || this.resultado.equipe.selectedCols.includes(c.key))
        },
        equipeColumns() {
            const columns = [
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true, fixed: true },
                { key: 'equipeDescricao', label: 'Equipe', sortable: true, fixed: true },
            ]

            if (this.model.boasPraticas.includes('A')) {
                columns.push({ key: 'denominadorBoaPraticaA', label: 'Denominador da boa prática A', sortable: true })
                columns.push({ key: 'numeradorBoaPraticaA', label: 'Numerador da boa prática A', sortable: true })
            }
            if (this.model.boasPraticas.includes('B')) {
                columns.push({ key: 'denominadorBoaPraticaB', label: 'Denominador da boa prática B', sortable: true })
                columns.push({ key: 'numeradorBoaPraticaB', label: 'Numerador da boa prática B', sortable: true })
            }
            if (this.model.boasPraticas.includes('C')) {
                columns.push({ key: 'denominadorBoaPraticaC', label: 'Denominador da boa prática C', sortable: true })
                columns.push({ key: 'numeradorBoaPraticaC', label: 'Numerador da boa prática C', sortable: true })
            }
            if (this.model.boasPraticas.includes('D')) {
                columns.push({ key: 'denominadorBoaPraticaD', label: 'Denominador da boa prática D', sortable: true })
                columns.push({ key: 'numeradorBoaPraticaD', label: 'Numerador da boa prática D', sortable: true })
            }

            columns.push({ key: 'resultado', formatter: v => `${v}%`, sortable: true, fixed: true })
            columns.push({ key: 'classificacaoResultado', label: 'Classificação', sortable: true, fixed: true })

            if (this.model.boasPraticas.includes('A')) {
                columns.push({ key: 'percentualBoaPraticaA', formatter: v => `${v}%`, sortable: true, class: 'text-center', fixed: true })
            }
            if (this.model.boasPraticas.includes('B')) {
                columns.push({ key: 'percentualBoaPraticaB', formatter: v => `${v}%`, sortable: true, class: 'text-center', fixed: true })
            }
            if (this.model.boasPraticas.includes('C')) {
                columns.push({ key: 'percentualBoaPraticaC', formatter: v => `${v}%`, sortable: true, class: 'text-center', fixed: true })
            }
            if (this.model.boasPraticas.includes('D')) {
                columns.push({ key: 'percentualBoaPraticaD', formatter: v => `${v}%`, sortable: true, class: 'text-center', fixed: true })
            }

            return columns
        },
        pacienteColumns() {
            const columns = [
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true, fixed: true },
                { key: 'equipeDescricao', label: 'Equipe', sortable: true, fixed: true },
                { key: 'pacienteNome', label: 'Paciente', sortable: true, fixed: true },
                { key: 'sexoDescricao', label: 'Sexo', sortable: true, fixed: true },
                { key: 'idade', label: 'Idade', sortable: true, fixed: true },
                { key: 'microareaDescricao', label: 'Microárea', sortable: true, fixed: true },
                { key: 'usuarioCadastroNome', label: 'Responsável pelo cadastro', sortable: true, fixed: true },
                { key: 'dataNascimento', label: 'Data de nascimento', formatter: v => v ? this.formatDate(v) : null, filterByFormatted: true, sortable: true },
                { key: 'telefonePrincipal', label: 'Telefone', sortable: true },
                { key: 'endereco', label: 'Endereço', sortable: true },
            ]

            if (this.model.boasPraticas.includes('A')) {
                columns.push({ key: 'boaPraticaA', class: 'text-center', fixed: true })
            }
            if (this.model.boasPraticas.includes('B')) {
                columns.push({ key: 'boaPraticaB', class: 'text-center', fixed: true })
            }
            if (this.model.boasPraticas.includes('C')) {
                columns.push({ key: 'boaPraticaC', class: 'text-center', fixed: true })
            }
            if (this.model.boasPraticas.includes('D')) {
                columns.push({ key: 'boaPraticaD', class: 'text-center', fixed: true })
            }

            columns.push({ key: 'pontuacaoTotal', label: 'Pontuação total', sortable: true, class: 'text-center', fixed: true })

            return columns
        },
    },
    created() {
        this.repositories = {
            relatorioCuidadoMulherPrevencaoCancer: this.getConectaSusRepository('atencaoBasica.relatorioCuidadoMulherPrevencaoCancer'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
        }

        this.load()
    },
    data() {
        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            pacienteSearchFields: [
                { key: 'cidadao.nome', searchable: true },
                { key: 'cidadao.cns', searchable: true },
                { key: 'cidadao.cpf', searchable: true },
                { key: 'paciente.prontuario', searchable: true },
            ],
            resultado: {
                equipe: {
                    itens: [],
                    sortBy: 'unidadeNomeFantasia',
                    sortDesc: false,
                    selectedAll: false,
                    indeterminate: false,
                    selectedCols: [],
                },
                paciente: {
                    itens: [],
                    sortBy: 'pacienteNome',
                    sortDesc: false,
                    selectedAll: false,
                    indeterminate: false,
                    selectedCols: [],
                },
            },
            totalizadores: null,
            unwatchers: {
                unwatchPeriodo: null,
                unwatchPaciente: null,
            },
            enums: { sexo },
            others: { moment },
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioCuidadoMulherPrevencaoCancer.create()
                .then(({ data }) => {
                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {
            this.unwatchers.unwatchPeriodo = this.$watch('model.periodo', {
                deep: true,
                handler() {
                    this.handlePeriodoChange()
                },
            })

            this.unwatchers.unwatchPaciente = this.$watch('model.paciente', () => this.clearResult())
        },
        handlePeriodoChange() {
            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.form.identidadesGenero = []
            this.model.quadrimestreAno = null
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.identidadeGeneroId = null
            this.model.paciente = null

            this.clearResult()

            if (this.model.periodo.start === null || this.model.periodo.end === null)  {
                return
            }

            this.loadFromUnidades()
        },
        handleQuadrimestreAnoChange() {
            this.removeWatchers()
            this.model.periodo = { start: null, end: null }
            this.addWatchers()
            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.form.identidadesGenero = []
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.identidadeGeneroId = null
            this.model.paciente = null

            this.clearResult()
        },
        handleQuadrimestreChange() {
            this.removeWatchers()
            this.model.periodo = { start: null, end: null }
            this.addWatchers()
            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.form.identidadesGenero = []
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.identidadeGeneroId = null
            this.model.paciente = null

            this.clearResult()

            if (this.model.quadrimestre === null) {
                return
            }

            this.loadFromUnidades()
        },
        handleUnidadeChange() {
            this.form.equipes = []
            this.form.sexos = []
            this.form.identidadesGenero = []
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.identidadeGeneroId = null
            this.model.paciente = null

            this.clearResult()
            this.loadFromEquipes()
        },
        handleEquipeChange() {
            this.form.sexos = []
            this.form.identidadesGenero = []
            this.model.sexoId = null
            this.model.identidadeGeneroId = null
            this.model.paciente = null

            this.clearResult()
            this.loadFromSexos()
        },
        handleBoasPraticasChange() {
            this.clearResult()
        },
        handleSexoChange() {
            this.form.identidadesGenero = []
            this.model.identidadeGeneroId = null
            this.model.paciente = null

            this.clearResult()
            this.loadFromIdentidadesGenero()
        },
        handleIdentidadeGeneroChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handleIdadeMinimaAnosChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handleIdadeMinimaMesesChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handleIdadeMinimaDiasChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handleIdadeMaximaAnosChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handleIdadeMaximaMesesChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handleIdadeMaximaDiasChange() {
            this.model.paciente = null

            this.clearResult()
        },
        handlePacienteChange() {
            this.clearResult()
        },
        handleBuscaAtivaChange() {
            this.clearResult()
        },
        loadFromUnidades() {
            const params = {
                listar: 'unidades',
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                boasPraticas: this.model.boasPraticas,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoMulherPrevencaoCancer.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.unidades = data.unidades
                    this.form.equipes = data.equipes
                    this.form.sexos = data.sexos
                    this.form.identidadesGenero = data.identidadesGenero
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFromEquipes() {
            const params = {
                listar: 'equipes',
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                boasPraticas: this.model.boasPraticas,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoMulherPrevencaoCancer.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.equipes = data.equipes
                    this.form.sexos = data.sexos
                    this.form.identidadesGenero = data.identidadesGenero
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFromSexos() {
            const params = {
                listar: 'sexos',
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoMulherPrevencaoCancer.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.sexos = data.sexos
                    this.form.identidadesGenero = data.identidadesGenero
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFromIdentidadesGenero() {
            const params = {
                listar: 'identidades_genero',
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoMulherPrevencaoCancer.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.identidadesGenero = data.identidadesGenero
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearResult() {
            this.resultado.equipe.itens = []
            this.resultado.paciente.itens = []
            this.totalizadores = null

            this.resultado.equipe.selectedAll = false
            this.resultado.equipe.indeterminate = false
            this.resultado.equipe.selectedCols = []
        },
        search() {
            const params = {
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                identidadeGeneroId: this.model.identidadeGeneroId,
                idadeMinimaAnos: this.model.idadeMinimaAnos,
                idadeMinimaMeses: this.model.idadeMinimaMeses,
                idadeMinimaDias: this.model.idadeMinimaDias,
                idadeMaximaAnos: this.model.idadeMaximaAnos,
                idadeMaximaMeses: this.model.idadeMaximaMeses,
                idadeMaximaDias: this.model.idadeMaximaDias,
                pacienteId: this.model.paciente?.id ?? null,
                buscaAtiva: this.model.buscaAtiva,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoMulherPrevencaoCancer.index(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.resultado.equipe.itens = data.equipes
                    this.resultado.paciente.itens = data.pacientes
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.removeWatchers()

            this.form.unidades = []
            this.form.equipes = []
            this.form.sexos = []
            this.form.identidadesGenero = []
            this.model.periodo = { start: null, end: null }
            this.model.quadrimestreAno = null
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.equipeId = null
            this.model.boasPraticas = this.form.boasPraticas.map(bp => bp.value)
            this.model.sexoId = null
            this.model.identidadeGeneroId = null
            this.model.idadeMinimaAnos = null
            this.model.idadeMinimaMeses = null
            this.model.idadeMinimaDias = null
            this.model.idadeMaximaAnos = null
            this.model.idadeMaximaMeses = null
            this.model.idadeMaximaDias = null
            this.model.paciente = null
            this.model.buscaAtiva = false
            this.addWatchers()
            this.clearResult()

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        removeWatchers() {
            this.unwatchers.unwatchPeriodo()
            this.unwatchers.unwatchPaciente()
        },
        print() {
            this.setLoading()

            const params = {
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                identidadeGeneroId: this.model.identidadeGeneroId,
                idadeMinimaAnos: this.model.idadeMinimaAnos,
                idadeMinimaMeses: this.model.idadeMinimaMeses,
                idadeMinimaDias: this.model.idadeMinimaDias,
                idadeMaximaAnos: this.model.idadeMaximaAnos,
                idadeMaximaMeses: this.model.idadeMaximaMeses,
                idadeMaximaDias: this.model.idadeMaximaDias,
                pacienteId: this.model.paciente?.id ?? null,
                buscaAtiva: this.model.buscaAtiva,
                colunasEquipes: this.fieldsEquipes.map(f => this.camelToSnake(f.key)),
                colunasPacientes: this.fieldsPacientes.map(f => this.camelToSnake(f.key)),
                equipeSortBy: this.camelToSnake(this.resultado.equipe.sortBy),
                equipeSortDesc: this.resultado.equipe.sortDesc,
                pacienteSortBy: this.camelToSnake(this.resultado.paciente.sortBy),
                pacienteSortDesc: this.resultado.paciente.sortDesc,
            }

            this.repositories.impressao.relatorioCuidadoMulherPrevencaoCancer(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const params = {
                periodo: this.hasPeriodo ? {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                } : null,
                quadrimestreAno: this.model.quadrimestreAno,
                quadrimestre: this.model.quadrimestre,
                unidadeId: this.model.unidadeId,
                equipeId: this.model.equipeId,
                boasPraticas: this.model.boasPraticas,
                sexoId: this.model.sexoId,
                identidadeGeneroId: this.model.identidadeGeneroId,
                idadeMinimaAnos: this.model.idadeMinimaAnos,
                idadeMinimaMeses: this.model.idadeMinimaMeses,
                idadeMinimaDias: this.model.idadeMinimaDias,
                idadeMaximaAnos: this.model.idadeMaximaAnos,
                idadeMaximaMeses: this.model.idadeMaximaMeses,
                idadeMaximaDias: this.model.idadeMaximaDias,
                pacienteId: this.model.paciente?.id ?? null,
                buscaAtiva: this.model.buscaAtiva,
                colunasEquipes: this.fieldsEquipes.map(f => this.camelToSnake(f.key)),
                colunasPacientes: this.fieldsPacientes.map(f => this.camelToSnake(f.key)),
                equipeSortBy: this.camelToSnake(this.resultado.equipe.sortBy),
                equipeSortDesc: this.resultado.equipe.sortDesc,
                pacienteSortBy: this.camelToSnake(this.resultado.paciente.sortBy),
                pacienteSortDesc: this.resultado.paciente.sortDesc,
            }

            this.repositories.exportacao.relatorioCuidadoMulherPrevencaoCancer(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        onSortChangedEquipes(context) {
            this.resultado.equipe.sortBy = context.sortBy
            this.resultado.equipe.sortDesc = context.sortDesc
        },
        onSortChangedPacientes(context) {
            this.resultado.paciente.sortBy = context.sortBy
            this.resultado.paciente.sortDesc = context.sortDesc
        },
        selectAllEquipes(selected) {

            this.resultado.equipe.selectedCols = selected ? this.optionalColumnsEquipes.map(c => c.key) : []
        },
        selectAllPacientes(selected) {

            this.resultado.paciente.selectedCols = selected ? this.optionalColumnsPacientes.map(c => c.key) : []
        },
    },
    mixins: [data, error, file, repository, stringCase, formats],
    watch: {
        'resultado.equipe.selectedCols'(newValue) {

            this.resultado.equipe.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumnsEquipes.length
            this.resultado.equipe.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumnsEquipes.length
        },
        'resultado.paciente.selectedCols'(newValue) {

            this.resultado.paciente.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumnsPacientes.length
            this.resultado.paciente.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumnsPacientes.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
.green {
    color: green;
}
.red {
    color: red;
}
.fg-faixa-etaria >>> legend {
    padding-bottom: 0 !important;
    margin-bottom: 3px;
}
</style>